import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";



class SweetAlertConfirm extends React.Component {
    constructor(props){
      super(props);
    }

    render(){
        /*
        Props:
          onConfirm
          confirmBtnMsg
          onClose
          message
          headerTitle
          type
        */
        const { onConfirm, onClose, message, headerTitle, confirmBtnMsg, type,classes} = this.props;

        return(
            

            <SweetAlert
              style={{ display: "block", marginTop: "-100px"}}
              title={headerTitle}
              onConfirm={onConfirm}
              onCancel={onClose}
              confirmBtnCssClass={
                classes.button + " " + this.props.classes.success
              }
              cancelBtnCssClass={
                classes.button + " " + this.props.classes.danger
              }
              confirmBtnText={confirmBtnMsg}
              cancelBtnText="Cancel"
              showCancel
              >
                {message}
            </SweetAlert>
        )
    }
}

export default  withStyles(sweetAlertStyle)(SweetAlertConfirm);


// WEBPACK FOOTER //
// ./src/views/etc/modals/SweetAlertConfirm.jsx